import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface CreateWebhookInput {
  Title: string;
  Description: string | null;
  WebhookUrl: string;
  WebhookApiVersion: string;
  WebhookEventTypeIds: string[];
}

/**
 * Normalised create result shared by both data paths. The GraphQL path
 * surfaces the base64 secret as `SigningSecret`; the tRPC path as
 * `plaintextSecret`. Wrappers return this common shape so the reveal modal
 * is agnostic to the active path.
 */
export interface CreateWebhookResult {
  plaintextSecret: string;
}

export const useCreateWebhookTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.webhook.create.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.list.queryKey(),
        });
      },
    }),
  });

  return {
    createWebhook: async (
      input: CreateWebhookInput
    ): Promise<CreateWebhookResult> => {
      const result = await mutation.mutateAsync(input);

      return { plaintextSecret: result.plaintextSecret };
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
